import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { MessagePhoto } from "../models/message";

export interface SecureDocumentUploadDto {
	type: string,
	pageCount: number
	isPublicDefender: boolean
}

export class SuccessfulUpload
{
	public photos: MessagePhoto[];
	public scannedImages: MessagePhoto[];
}

export class UploadedSecureDocument {
	public id: string;
	public url: string;
	public filename: string;
}

export class SuccessfulDocumentUpload
{
	public documents: UploadedSecureDocument[];
}

@Injectable()
export class PhotoRepository
{
	private http: HttpClient;

	public constructor(http: HttpClient)
	{
		this.http = http;
	}

	public uploadFiles(files: any, path: string): Observable<SuccessfulUpload>
	{
		return this.http.post<SuccessfulUpload>(`${path}`, files, {
			reportProgress: true,
			responseType: "json"
		});
	}

	public uploadDocuments(files: any, path: string): Observable<SuccessfulDocumentUpload>
	{
		return this.http.post<SuccessfulDocumentUpload>(`${path}`, files, {
			reportProgress: true,
			responseType: "json"
		});
	}

	public deletePhoto(messageId: string, photoId: string): Observable<void>
	{
		return this.http.delete<void>(`drafts/${messageId}/photos/${photoId}`);
	}

	public deleteScannedImages(messageId: string, type: string, fileId: string): Observable<void>
	{
		return this.http.delete<void>(`drafts/${messageId}/files/${fileId}?fileType=${type}`);
	}
}
